<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <div style="text-align: right;margin-bottom: 8px;">
            <el-button type="primary" size="small" @click="addRole">新增角色</el-button>
        </div>
        <el-table border v-bind:data="list">
            <el-table-column label="角色">
                <template v-slot="scope">
                    <span>{{ scope.row.role_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250px">
                <template v-slot="scope">
                    <el-button type="danger" size="small" @click="deleteUserRole(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="新增角色" v-model="dialogFormVisible" width="400px">
            <el-form :model="form" ref="formRef" size="small" label-width="70px" :rules="rules">
                <el-form-item label="角色：" prop="role_id">
                    <el-select v-model="form.role_id">
                        <el-option v-for="item in rolelist" v-bind:key="item.id" v-bind:label="item.name"
                            v-bind:value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="addconfirm(formRef)">新增</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import api from '../../../../axios/api'

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const list = ref([])
        const dialogFormVisible = ref(false)
        const formRef = ref()
        const form = reactive({
            role_id: '',
            adminer_id: '',
        })
        const rolelist = ref([])
        const rules = reactive({
            role_id: [{ required: true, message: '请选择角色', trigger: 'change' }],
        })

        const getRoleList = async () => {
            const res = await api.SalesPartnerPermissionRoleList({
                page: 1,
                limit: 1000,
            })
            if (res.data.code == 200) {
                rolelist.value = res.data.data.data
            }
        }

        const goback = () => {
            router.go(-1)
        }

        const addRole = () => {
            dialogFormVisible.value = true
        }

        const getList = async (id) => {
            const res = await api.SalesPartnerPermissionUserRoleList({
                adminer_id: id
            })
            if (res.data.code == 200) {
                list.value = res.data.data
            }
        }

        const deleteUserRole = (row) => {
            ElMessageBox.confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.SalesPartnerPermissionUserRoleDelete({
                        id: row.id
                    })
                    if (res.data.code == 200) {
                        ElMessage.success('删除成功')
                        getList(form.adminer_id)
                    } else {
                        ElMessage.error('删除失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消删除')
                })
        }

        const addconfirm = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    const res = await api.SalesPartnerPermissionUserRoleUpdate({
                        role_id: form.role_id,
                        adminer_id: form.adminer_id
                    })
                    if (res.data.code == 200) {
                        ElMessage.success('新增成功')
                        dialogFormVisible.value = false
                        getList(form.adminer_id)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        onMounted(() => {
            getRoleList()
            const id = route.params.id
            if (id) {
                form.adminer_id = Number(id)
                getList(id)
            }
        })

        return {
            list,
            dialogFormVisible,
            form,
            rolelist,
            getRoleList,
            goback,
            addRole,
            deleteUserRole,
            rules,
            formRef,
            addconfirm
        }
    },
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
        padding-left: 16px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
